export default __webpack_public_path__ + "static/media/HFS00513_WEDDING_1053_tn.72006093.jpg";